import Cookies from "universal-cookie";

const cookies = new Cookies();

// Same dedicated back-office RestApi used by the supplier explorer and audit module.
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const integrationsFetch = async (path, { method = "GET", body } = {}) => {
  const { token } = cookies.get("userId") || {};
  try {
    const res = await fetch(`${BASE}${path}`, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) return data ?? { message: "Erro ao comunicar com o servidor" };
    return data;
  } catch {
    return null;
  }
};

const structuredError = (status, data) => ({
  status,
  code: typeof data?.code === "string" ? data.code : "request_failed",
  message: typeof data?.message === "string"
    ? data.message
    : "Não foi possível concluir a operação.",
  retryable: data?.retryable === true,
  correlationId: typeof data?.correlationId === "string" ? data.correlationId : null,
});

const previsionFetch = async (path, { method = "GET", body } = {}) => {
  const { token } = cookies.get("userId") || {};
  let res;
  try {
    res = await fetch(`${BASE}${path}`, {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body ? { "Content-Type": "application/json" } : {}),
      },
      body: body ? JSON.stringify(body) : undefined,
    });
  } catch {
    throw structuredError(0, {
      code: "network_error",
      message: "Não foi possível comunicar com o servidor.",
      retryable: true,
    });
  }

  const data = await res.json().catch(() => null);
  if (!res.ok) throw structuredError(res.status, data);
  return data;
};

export const fetchIntegrations = () => integrationsFetch(`/integrations/list`);

export const saveIntegration = (companyId, patch) =>
  integrationsFetch(`/integrations/company?company_id=${encodeURIComponent(companyId)}`, {
    method: "PATCH",
    body: patch,
  });

export const testWriteback = (companyId) =>
  integrationsFetch(`/integrations/testWriteback?company_id=${encodeURIComponent(companyId)}`, {
    method: "POST",
  });

export const revealPrevisionToken = (companyId) =>
  integrationsFetch(`/integrations/previsionToken?company_id=${encodeURIComponent(companyId)}`);

export const fetchPrevisionProjects = (companyId) =>
  previsionFetch(`/integrations/prevision/projects?company_id=${encodeURIComponent(companyId)}`);

export const savePrevisionMapping = (companyId, buildingId, projectId) =>
  previsionFetch(`/integrations/prevision/mapping?company_id=${encodeURIComponent(companyId)}`, {
    method: "PUT",
    body: { buildingId, projectId },
  });

export const syncPrevisionBaseline = (companyId, buildingId) =>
  previsionFetch(`/integrations/prevision/sync?company_id=${encodeURIComponent(companyId)}`, {
    method: "POST",
    body: { buildingId },
  });

// Projetos MEGA vinculados à filial (o "Código da Obra" das obras MEGA). Usa o mesmo fetch
// estruturado do Prevision: lança `{status, code, message}` em vez de engolir o erro, para o
// formulário dizer por que a busca falhou (credencial, timeout, filial inválida).
export const fetchMegaProjects = (companyId, filial) =>
  previsionFetch(
    `/integrations/mega/projects?company_id=${encodeURIComponent(companyId)}`
    + `&filial=${encodeURIComponent(filial)}`
  );
